























































































































import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import Loader from "@/resources/mixins/loader/loader";
import { Validate } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import { i18n } from "@/resources/locales";
@Component({})
export default class AutoLoginMicrosoftView extends mixins(Vue, Loader) {
  token = null;
  tenantId = null;
  isTeams = null;
  active = false;
  activeError = false;
  activeSelectSpace = false;
  messageError = "";
  loading = false;
  spaceTypes = [
    { id: 1, name: i18n.t(`spaceType.OFFICE_TYPE`), type: "OFFICE_TYPE" },
    { id: 2, name: i18n.t(`spaceType.EVENT_TYPE`), type: "EVENT_TYPE" },
    { id: 3, name: i18n.t(`spaceType.EKAM_TYPE`), type: "EKAM_TYPE" },
    { id: 4, name: i18n.t(`spaceType.MINISO_TYPE`), type: "MINISO_TYPE" },
    { id: 5, name: i18n.t(`spaceType.LEARNING_TYPE`), type: "LEARNING_TYPE" },
  ];
  spaces = [];
  @Validate({ required })
  nameSpace = "";
  @Validate({ required })
  selectType = "";
  @Validate({ required })
  selectSpace = -1;
  loadSpaces = false;
  mounted(): void {
    this.startLoader(this.$store);
    this.token = this.$route.query.token;
    this.tenantId = this.$route.query.tenantId;
    this.isTeams = this.$route.query.isTeams;
    localStorage.setItem("isTeams", this.isTeams.toString());
    this.$store.dispatch("SpaceStore/getGlobalParamsAction", {
      callback: async (response) => {
        if (response.data.MAINTENANCE_STATUS == "OFF") {
          this.autoLogin();
        } else {
          this.active = true;
          this.stopLoader(this.$store);
        }
      },
      callbackError: (error) => {
        this.active = true;
        this.stopLoader(this.$store);
      },
    });
  }
  get imageScenne() {
    if (this.selectSpace > 0) {
      return this.spaces.filter((a) => a.id == this.selectSpace)[0];
    }
    return null;
  }
  autoLogin(): void {
    this.$store.dispatch("AuthStore/autoLoginMicrosoftAction", {
      data: { appToken: this.token != "null" ? this.token: null, tenantId: this.tenantId },
      callback: (response) => {
        this.stopLoader(this.$store);
        if (response.data.token) {
          localStorage.setItem("guestInvitationToken", response.data.token);
          localStorage.setItem(
            "guestInvitationRefreshToken",
            response.data.refresh_token
          );
          if (response.data.superSpaceId !== null) {
            localStorage.setItem(
              "super_space_id_default",
              response.data.superSpaceId
            );
            this.$router.push("/quickstart").catch(() => {});
            location.reload();
          } else {
            this.stopLoader(this.$store);
            this.activeSelectSpace = true;
          }
        } else {
          this.activeError = true;
          this.messageError = response;
          this.stopLoader(this.$store);
        }
      },
      callbackError: (error) => {
        this.activeError = true;
        this.messageError =" Code " + error.response.data.status +  " Detail " + error.response.data.detail;
        this.stopLoader(this.$store);
      },
    });
  }
  reload(): void {
    location.reload();
  }
  getScenes(): void {
    this.loadSpaces = true;
    this.selectSpace = -1;
    this.spaces = [];
    let space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getScenesTypesAction", {
      spaceType: this.selectType,
      superSpaceId: space.superSpace.id,
      callback: (response) => {
        this.loadSpaces = false;
        this.spaces = response;
        this.selectSpace = response[0].id;
      },
      callbackError: (error) => {
        this.loadSpaces = false;
      },
    });
  }
  createSapce(): void {
    this.$store.dispatch("SpaceStore/createByTeamsAction", {
      data: {
        appToken: this.token,
        tenantId: this.tenantId,
        name: this.nameSpace,
        scenarioType: this.selectSpace,
        type: this.selectType,
      },
      callback: (response) => {
        localStorage.setItem(
          "super_space_id_default",
          response.data.superSpace.id
        );
        this.$router.push("/quickstart").catch(() => {});
        location.reload();
      },
      callbackError: (error) => {
        this.activeError = true;
        this.messageError =" Code " + error.response.data.status +  " Detail " + error.response.data.detail;
        this.loadSpaces = false;
      },
    });
  }
}
